import React from "react";
import WorkplaceSection from "./WorkplaceSection";

const Service3 = () => {
  return <WorkplaceSection />;
};

export default Service3;